import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

const PortlandSeaDogsLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=POSM_MYTIXX&orgid=56874#/auth/login"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Buy More and Save Plan account using our secure MyProvenue Login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <PortlandSeaDogsLink /> account within
        24 hours of purchase. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Sea Dogs Buy More Earn More Plan work?",
    description:
      "The Sea Dogs Buy More Earn More Plan allows fans to select any seat to select games hosted by the Portland Sea Dogs. Depending on the number of games you select, you can unlock different rewards for each level! Don't miss our on Simply log into your MLB.com and select games.",
  },
  {
    title: "What are the different experiences that I can unlock?",
    description:
      "There are 3 main experiences that fans can unlock! At 3 games, you will receive an exclusive official League x Sea Dogs Collab scarf. At 5 games you will receive 4 complimentary Opening Day tickets with your order. At 10 or more games, you and your guests have the opportunity to take batting practice on the field for one of the games you have elected to attend.",
  },
  {
    title: "How do I claim my experience?",
    description: (
      <>
        These experiences will be honored through the Portland Sea Dogs box
        office. The team will be in touch after you complete your order
        regarding next steps for claiming or setting up your experience. The Box
        Office can be reached at{" "}
        <Link
          href="tel:2078799500"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (207) 879-9500
        </Link>
      </>
    ),
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Portland Sea Dogs{" "}
        <PortlandSeaDogsLink /> Account.
      </>
    ),
  },
];
